import React from 'react';
import { Result, Button } from 'antd';
const toIndex=()=>{
    window.location.hash='#/'
};
function Error() {
    return (
        <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={toIndex}>返回首页</Button>}
        />
    )
}
export default Error